export default __webpack_public_path__ + "static/media/signlanguage.1e53dd00.png";